import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { moduleActionContext } from '@/store';
const cvModule = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default cvModule;
export const cvModuleActionContext = (context) => moduleActionContext(context, cvModule);
